import { createApp } from 'vue'
import App from './App.vue'
import { createPinia } from 'pinia';

import 'animate.css';
import '../src/output.css'

import FlowerIcon from './components/FlowerIcon.vue';

const pinia = createPinia();

createApp(App)
.use(pinia)
.component('flower-icon', FlowerIcon)
.mount('#app')
